const baseClassName = 'typography';
export class TypographyPrefixedContext {
    constructor() {
        this.prefix = '';
        this.generateClassNames = (textGroup, textStyle, regular) => {
            const baseClass = `${this.prefix}${baseClassName}`;
            const regularClass = regular ? ` ${baseClass}-regular` : '';
            const appendix = textStyle ? `-${textStyle}` : '';
            return `${baseClass}-${textGroup}${appendix}${regularClass}`;
        };
        this.generateContextClassNames = (contextGroup, selectedContext) => {
            const baseClass = `${this.prefix}${baseClassName}`;
            return `${baseClass}-${contextGroup} ${baseClass}-${selectedContext}`;
        };
    }
    get TypographyRoot() {
        return `${this.Context.TypeScale.Desktop}`;
    }
    get Context() {
        const genClasses = this.generateClassNames.bind(this);
        return {
            opticalEdgeAlign: `${this.prefix}${baseClassName}-margin-compensation`,
            paragraphSpacing: `${this.prefix}${baseClassName}-paragraph-spacing`,
            get BaseSize() {
                const baseClasses = genClasses.bind(this, 'base');
                return {
                    base14: baseClasses('14'),
                    base16: baseClasses('16'),
                    base20: baseClasses('20'),
                    base28: baseClasses('28'),
                    base56: baseClasses('56'),
                };
            },
            get TypeScale() {
                const scaleClasses = genClasses.bind(this, 'typescale');
                return {
                    Auto: scaleClasses('auto'),
                    Desktop: scaleClasses('desktop'),
                    SmallScreen: scaleClasses('small-screen'),
                    LargeScreen: scaleClasses('large-screen'),
                };
            },
            get CharacterSet() {
                const charClasses = genClasses.bind(this, 'character-set');
                return {
                    LatinCyrillicGreek: charClasses('latin_cyrill_greek'),
                    Arabic: charClasses('arabic'),
                    ChineseSimplified: charClasses('chinese_simplified'),
                    ChineseTraditional: charClasses('chinese_traditional'),
                    Hebrew: charClasses('hebrew'),
                    Japanese: charClasses('japanese'),
                    Korean: charClasses('korean'),
                    Thai: charClasses('thai'),
                };
            },
        };
    }
    get Display() {
        const displayClasses = this.generateClassNames.bind(this, 'display');
        return {
            M: displayClasses('m'),
            L: displayClasses('l'),
            XL: displayClasses('xl'),
        };
    }
    get DisplayRegular() {
        const displayClasses = this.generateClassNames.bind(this, 'display');
        return {
            M: displayClasses('m', true),
            L: displayClasses('l', true),
            XL: displayClasses('xl', true),
        };
    }
    get Heading() {
        const headingClasses = this.generateClassNames.bind(this, 'heading');
        return {
            XS: headingClasses('xs'),
            S: headingClasses('s'),
            M: headingClasses('m'),
            L: headingClasses('l'),
            XL: headingClasses('xl'),
        };
    }
    get HeadingRegular() {
        const headingClasses = this.generateClassNames.bind(this, 'heading');
        return {
            XS: headingClasses('xs', true),
            S: headingClasses('s', true),
            M: headingClasses('m', true),
            L: headingClasses('l', true),
            XL: headingClasses('xl', true),
        };
    }
    get Statement() {
        const statementClasses = this.generateClassNames.bind(this, 'statement');
        return {
            M: statementClasses('m'),
            L: statementClasses('l'),
        };
    }
    get Body() {
        const bodyClasses = this.generateClassNames.bind(this, 'body');
        return {
            S: bodyClasses('s'),
            M: bodyClasses('m'),
            L: bodyClasses('l'),
        };
    }
    get Label() {
        const labelClasses = this.generateClassNames.bind(this, 'label');
        return {
            XS: labelClasses('xs'),
            S: labelClasses('s'),
            M: labelClasses('m'),
            L: labelClasses('l'),
        };
    }
    get LabelRegular() {
        const labelClasses = this.generateClassNames.bind(this, 'label');
        return {
            XS: labelClasses('xs', true),
            S: labelClasses('s', true),
            M: labelClasses('m', true),
            L: labelClasses('l', true),
        };
    }
    get Caption() {
        const captionClasses = this.generateClassNames.bind(this, 'caption');
        return {
            S: captionClasses('s'),
            M: captionClasses('m'),
            L: captionClasses('l'),
        };
    }
}
export const Typography = new TypographyPrefixedContext();
